/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { UserPreferenceGetSetSettings } from '../models/user-preference-get-set-settings';
import { userPreferenceSettingGetUserPreferenceSettings } from '../fn/user-preference-setting/user-preference-setting-get-user-preference-settings';
import { UserPreferenceSettingGetUserPreferenceSettings$Params } from '../fn/user-preference-setting/user-preference-setting-get-user-preference-settings';
import { userPreferenceSettingUpdateUserPreferenceSetting } from '../fn/user-preference-setting/user-preference-setting-update-user-preference-setting';
import { UserPreferenceSettingUpdateUserPreferenceSetting$Params } from '../fn/user-preference-setting/user-preference-setting-update-user-preference-setting';

@Injectable({ providedIn: 'root' })
export class UserPreferenceSettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userPreferenceSettingGetUserPreferenceSettings()` */
  static readonly UserPreferenceSettingGetUserPreferenceSettingsPath = '/api/UserPreferenceSetting/getuserpreferencesetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPreferenceSettingGetUserPreferenceSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPreferenceSettingGetUserPreferenceSettings$Response(params?: UserPreferenceSettingGetUserPreferenceSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPreferenceGetSetSettings>> {
    return userPreferenceSettingGetUserPreferenceSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPreferenceSettingGetUserPreferenceSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userPreferenceSettingGetUserPreferenceSettings(params?: UserPreferenceSettingGetUserPreferenceSettings$Params, context?: HttpContext): Observable<UserPreferenceGetSetSettings> {
    return this.userPreferenceSettingGetUserPreferenceSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPreferenceGetSetSettings>): UserPreferenceGetSetSettings => r.body)
    );
  }

  /** Path part for operation `userPreferenceSettingUpdateUserPreferenceSetting()` */
  static readonly UserPreferenceSettingUpdateUserPreferenceSettingPath = '/api/UserPreferenceSetting/updateUserPreferenceSetting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPreferenceSettingUpdateUserPreferenceSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userPreferenceSettingUpdateUserPreferenceSetting$Response(params: UserPreferenceSettingUpdateUserPreferenceSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return userPreferenceSettingUpdateUserPreferenceSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userPreferenceSettingUpdateUserPreferenceSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userPreferenceSettingUpdateUserPreferenceSetting(params: UserPreferenceSettingUpdateUserPreferenceSetting$Params, context?: HttpContext): Observable<Blob> {
    return this.userPreferenceSettingUpdateUserPreferenceSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
